import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Sua configuração do Firebase que você acabou de me enviar
const firebaseConfig = {
  apiKey: "AIzaSyDelMXk9_71t7WcR9L9ZxyXX8fszRBq8Ds",
  authDomain: "chale-b3fa0.firebaseapp.com",
  databaseURL: "https://chale-b3fa0-default-rtdb.firebaseio.com",
  projectId: "chale-b3fa0",
  storageBucket: "chale-b3fa0.appspot.com", // Corrigido de firebasestorage.app para appspot.com
  messagingSenderId: "1080999618858",
  appId: "1:1080999618858:web:28f4cf02ce3219bb3d1653"
};

// Inicializa o Firebase
const app = initializeApp(firebaseConfig);

// Inicializa os serviços que vamos usar no projeto
const db = getFirestore(app);
const auth = getAuth(app);

// Exporta os serviços para serem usados em outros arquivos
export { db, auth };